export const promoStatuses = {
  ACTIVE: 'Активний', DISABLED: 'Вимкнений', SCHEDULED: 'Ще не діє', EXPIRED: 'Строк завершився', EXHAUSTED: 'Ліміт вичерпано',
};
export const promoSortFields = {
  id: 'ID', code: 'Код', discountValue: 'Знижка', startsAt: 'Початок дії', expiresAt: 'Завершення дії', usageCount: 'Використання', createdAt: 'Дата створення',
};
const textFields = ['search', 'discountType', 'campaignSource', 'categoryScope', 'id', 'assignedUserId', 'discountFrom', 'discountTo'];
export const readPromoListQuery = search => {
  const params = new URLSearchParams(search);
  const query = Object.fromEntries(textFields.map(key => [key, params.get(key) || '']));
  query.status = params.getAll('status');
  const page = Number(params.get('page'));
  query.page = Number.isSafeInteger(page) && page > 0 ? page : 1;
  const limit = Number(params.get('limit'));
  query.limit = [25, 50, 100].includes(limit) ? limit : 25;
  query.sortBy = params.get('sortBy') || 'id';
  query.sortOrder = params.get('sortOrder') || 'desc';
  return query;
};
export const updatePromoListQuery = (search, changes) => {
  const params = new URLSearchParams(search);
  Object.entries(changes).forEach(([key, value]) => {
    params.delete(key);
    (Array.isArray(value) ? value : [value]).forEach(item => {
      if (item != null && item !== '') params.append(key, String(item));
    });
  });
  if (!Object.prototype.hasOwnProperty.call(changes, 'page')) params.set('page', '1');
  return `?${params.toString()}`;
};
export const promoListParams = query => ({
  ...Object.fromEntries(textFields.filter(key => query[key] !== '').map(key => [key, query[key]])),
  status: query.status, limit: query.limit, offset: (query.page - 1) * query.limit,
  sortBy: query.sortBy, sortOrder: query.sortOrder,
});

// Older API responses may omit the computed status; use the same display precedence.
// List filtering and ordering still always run on the server.
export const getPromoStatus = (promo, now = Date.now()) => {
  if (promoStatuses[promo.status]) return promo.status;
  if (!promo.isActive) return 'DISABLED';
  const utc = value => Date.parse(/(?:Z|[+-]\d\d:\d\d)$/.test(value) ? value : `${value}Z`);
  if (promo.startsAt && utc(promo.startsAt) > now) return 'SCHEDULED';
  if (promo.usageLimitTotal != null && (promo.usageCount || 0) >= promo.usageLimitTotal) return 'EXHAUSTED';
  if (promo.expiresAt && utc(promo.expiresAt) <= now) return 'EXPIRED';
  return 'ACTIVE';
};
